import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import { useCallback } from "react";

interface PartnerInfo {
  partnerId: number;
  name: string;
  apiKey?: string;
  partnerUid: string;
  logoUrl?: string; // These are public URLs, so no S3 download needed
}

export const useLoadPartners = ({
  enabled = true,
}: { enabled?: boolean } = {}) => {
  return useApi<PartnerInfo[]>({
    queryOptions: {
      queryFn: async () => {
        const response = await axiosInstance.get<PartnerInfo[]>(
          "/internal/partner/partner/info/all",
        );
        return response.data;
      },
      enabled,
      staleTime: Number.POSITIVE_INFINITY,
      gcTime: Number.POSITIVE_INFINITY,
      queryKey: ["/partner/info/all"],
      select: useCallback((partners: PartnerInfo[]) => {
        // Curai and Amazon are not stored in partner config since there are no
        // user affiliation models using them.
        return [
          ...partners,
          {
            partnerId: 9999990,
            name: "Curai",
            partnerUid: "curai",
            logoUrl:
              "https://public-curai.s3.us-west-2.amazonaws.com/logos/curai.svg",
          },
          {
            partnerId: 9999991,
            name: "Amazon",
            partnerUid: "amazon",
            logoUrl:
              "https://public-curai.s3.us-west-2.amazonaws.com/logos/amazon.svg",
          },
        ];
      }, []),
    },
  });
};
